import { FormControl, FormHelperText, InputLabel, Select as MUISelect, MenuItem, SelectProps } from '@material-ui/core';
import React from 'react';

interface IKeyValue {
  key: string;
  value: string;
}

type Props = {
  fullWidth?: boolean;
  label?: string;
  errorMessage?: string;
  data: IKeyValue[];
  hasMargin?: boolean;
} & SelectProps;
const SelectCountryState: React.FC<Props> = ({ fullWidth, label, errorMessage, data, hasMargin = true, ...props }) => {
  return (
    <FormControl margin={hasMargin ? 'normal' : undefined} fullWidth={fullWidth} error={!!errorMessage}>
      {!!label && <InputLabel shrink>{label}</InputLabel>}

      <MUISelect disableUnderline {...props} error={!!errorMessage}>
        {data.map((item) => (
          <MenuItem value={item.value} key={item.key}>
            {item.key}
          </MenuItem>
        ))}
      </MUISelect>
      {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

export default SelectCountryState;

SelectCountryState.defaultProps = {
  fullWidth: false,
};
